<div>
    <h2 class="title is-level-4">{{ equipment.data.manufacturer }} {{ equipment.name }}</h2>
    <div class="columns is-mobile is-multiline is-justified-center">
        <div class="column is-narrow">
            <picture>
                <img [defaultImage]="defaultImage" [lazyLoad]="images" [useSrcset]="true" alt="" class="phone-image" />
            </picture>
        </div>
        <div class="column has-text-left">
            <div class="columns is-gapless is-multiline">
                <div class="column is-aligned-top is-12">
                    <p class="text is-level-3 mb-0">
                        <span class="is-block">Capacité {{ equipment.data.capacity }}</span>
                        <span class="is-block">Couleur {{ equipment.data.color }}</span>
                        @if (isPreOrder && formatedPreorderDate) {
                            <span class="is-block">
                                <span class="icon-and-text">
                                    <span class="icon is-small has-text-info">
                                        <i class="tri-calendar-clock-circle"></i>
                                    </span>
                                    <span>Disponible à partir du {{ formatedPreorderDate | date: 'longDate' }}</span>
                                </span>
                            </span>
                        }
                    </p>
                </div>
                <div class="column is-12">
                    @if (funding) {
                        <div class="is-12 has-text-left mt-1">
                            @if (hasCoupon) {
                                <trg-price
                                    [price]="commercialProposal.initialAmount"
                                    [isDiscountPrice]="true"
                                    class="is-margin"
                                    [size]="'is-level-6'"
                                />
                            }
                            <trg-price
                                [price]="mainPriceToDisplay"
                                [size]="'is-size-3 has-text-weight-bold'"
                                [isInlined]="true"
                            />
                            @if (odrAmount) {
                                <p class="text is-level-4 mb-0">
                                    <span>Soit&#32;</span>
                                    <trg-price
                                        [inheritFontSize]="true"
                                        [price]="commercialProposal?.initialAmount"
                                        [isInlined]="true"
                                    />
                                    <span>&#32;puis&#32;</span>
                                    <trg-price [inheritFontSize]="true" [price]="odrAmount" [isInlined]="true" />
                                    <span>&#32;remboursés après achat</span>
                                </p>
                            }
                            <p class="text is-level-3 has-text-weight-bold mt-xs">
                                <span>+</span>
                                <trg-price
                                    [size]="'text is-level-3 mb-0'"
                                    [price]="commercialProposal?.monthlyAmount"
                                    [hasPeriod]="true"
                                    [isInlined]="true"
                                />
                                <span class="text is-level-3 is-relative">
                                    &nbsp;pendant&#32;{{ commercialProposal?.nbLoan }}&#32;mois
                                    <span (click)="showFundingDetails()" class="icon is-small has-cursor is-absolute">
                                        <i class="tri-infos-circle"></i>
                                    </span>
                                </span>
                            </p>
                        </div>
                    }
                    @if (!funding) {
                        <div class="is-12 has-text-left mt-1">
                            <!-- @if (canShowInitialPrice && basePrice - odrAmount > mainPriceToDisplay) {
                                <trg-price
                                    [isDiscountPrice]="true"
                                    [price]="basePrice - odrAmount"
                                    class="is-margin"
                                    [size]="'is-5'"
                                />
                            } -->
                            <trg-price
                                [price]="mainPriceToDisplay"
                                class="is-margin"
                                [size]="'is-size-3 has-text-weight-bold'"
                                checkoutCy="recap_price"
                                [isInlined]="true"
                            />
                            @if (odrAmount) {
                                @if (hasCoupon) {
                                    <p class="text is-level-3">
                                        Ce prix inclut la remise immédiate de {{ equipment.promotions.coupon.amount }} €
                                        ainsi que l'offre de remboursement après achat de {{ odrAmount }} €
                                    </p>
                                } @else {
                                    <p class="text is-level-3">
                                        <span>Soit&#32;</span>
                                        <trg-price
                                            [price]="equipment.prices.final"
                                            [isInlined]="true"
                                            [inheritFontSize]="true"
                                        />
                                        <span>&#32;puis&#32;</span>
                                        <trg-price [price]="odrAmount" [isInlined]="true" [inheritFontSize]="true" />
                                        <span>&#32;remboursés après achat</span>
                                    </p>
                                }
                            }
                            @if (showEdp && edp) {
                                <p class="has-text-weight-bold text is-level-3">
                                    + {{ edp.data.price }}
                                    <span>€/mois pendant</span>
                                    {{ edp.data.duration }}
                                    <span>mois</span>
                                </p>
                            }
                        </div>
                    }
                    @if (odrAmount) {
                        <div class="mt-1">
                            <a
                                [href]="equipment.data.odr.file"
                                class="link is-size-7"
                                rel="noopener noreferrer"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Télécharger l'offre de remboursement
                            </a>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
@if (rsfAmount) {
    <div class="is-block">
        <a [href]="rsfPdf" class="link is-size-7" rel="noopener noreferrer" target="_blank" rel="noopener noreferrer">
            {{ rsfAmount }}
            <span>€ remboursés sur votre 3ème facture</span>
        </a>
    </div>
}
